import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  navContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyItems: 'center',
    minWidth: 'fit-content',
  },
  cardId: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 700,
    color: '#2C2D3E',
  },
  cardWithoutNavigation: {
    margin: '0 12px 0 12px',
  },
  navIcon: {
    width: '30px',
    padding: '3px',
    '&:hover': {
      backgroundColor: 'rgba(202, 202, 252, 0.3)',
    },
  },
  fullscreenMode: {
    marginLeft: '17px',
  },
  customTooltip: {
    backgroundColor: '#2C2D3E',
  },
  customArrow: {
    color: '#2C2D3E',
  },
}));
